import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";

import { AuthProvider } from "react-auth-kit";
import { refreshApi } from "./auth/refreshApi";

import styled from 'styled-components';
import { LanguageProvider } from './i18n/LanguageProvider';
import { CurrencyProvider } from './currency/CurrencyProvider';

// Initialize Bootstrap theme: 'light' | 'dark'
(function initBootstrapTheme() {
  try {
    const stored = localStorage.getItem('theme');
    const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    const theme = stored || (prefersDark ? 'dark' : 'light');
    document.documentElement.setAttribute('data-bs-theme', theme);
  } catch (_) {
    document.documentElement.setAttribute('data-bs-theme', 'light');
  }
})();

const Centered = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider
      authType={"cookie"}
      authName={"_auth"}
      refresh={refreshApi}
      cookieDomain={window.location.hostname}
      // Secure cookies in production (HTTPS); off on localhost (http) so dev
      // login still works — Secure cookies are dropped on non-HTTPS origins.
      cookieSecure={window.location.protocol === "https:"}
    >
      <LanguageProvider>
        <CurrencyProvider>
          <Centered>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </Centered>
        </CurrencyProvider>
      </LanguageProvider>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
